import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LoadingController, ModalController} from '@ionic/angular';
import {SearchcustomerPage} from 'src/app/modals/searchcustomer/searchcustomer.page';
import {CustomerModel} from '../../models/customer.model';
import {OrdersForCustomerPage} from '../../modals/orders-for-customer/orders-for-customer.page';
import {DocumentModel} from '../../models/document.model';
import {CustomerResourceService} from '../../services/database/resource/customer-resource.service';
import {GeneralService} from '../../services/general.service';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {ConfigurationService} from '../../services/configuration.service';
import {DocumentTypes} from '../../definitions/document-types';
import {ConfigurationModel} from '../../models/configuration.model';
import {SelectCurrentCustomerService} from '../../services/select-current-customer.service';
import { CollectionsNames } from 'src/app/definitions/collections-names';
import { StateManagerService } from 'src/app/services/state-manager.service';

@Component({
    selector: 'customer',
    templateUrl: './customer.component.html',
    styleUrls: ['./customer.component.scss'],
})
export class CustomerComponent implements OnInit {

    @Input() document: DocumentModel;
    @Output() customerChange: EventEmitter<CustomerModel> = new EventEmitter<CustomerModel>();
    @Output() documentChange: EventEmitter<DocumentModel> = new EventEmitter<DocumentModel>();
    @Output() ordersListChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() contractListChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() readonly: boolean = false;

    ordersList: any;
    contractList: any;
    customerList: any;
    depots: any[];
    loading: any;
    mobileConfig: MobileConfigurationModel;
    private configuration: ConfigurationModel;

    constructor(private customerRes: CustomerResourceService,
                private modalController: ModalController,
                private loadingController: LoadingController,
                private generalServices: GeneralService,
                private config: ConfigurationService,
                public docTypes: DocumentTypes,
                private selectCurrentCustomerService: SelectCurrentCustomerService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames) {
    }

    ngOnInit() {
        this.mobileConfig = this.config.getMobileConfiguration();
        this.configuration = this.config.getConfiguration();
        this.populateDepotList();
        if (this.configuration && this.configuration.currentCustomer) {
            this.document.customer = this.configuration.currentCustomer;
        }
        if (!this.document.customer.name && this.document.documentType !== this.docTypes.SERVICEJOB && this.document.documentType !== this.docTypes.CHANGEOVER && 
            this.document.documentType !== this.docTypes.MODIFYCONTRACT ) {
            this.openModal(1);
        }
    }
    populateDepotList(){
        this.depots = this.stateManager.getCollection(this.collectionNames.DEPOT);
    }

    async openModal(ind) {
        let page = null;
        if (ind === 1) {
            page = SearchcustomerPage;
        } else if (ind === 2) {
            page = OrdersForCustomerPage;
        }
        const modal = await this.modalController.create({
            component: page,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'customerList': this.customerList,
                'document': this.document,
                'type': 'order',
                'ordersList': this.ordersList,
                'contractList': this.contractList
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.customerChange.emit(dataReturned.data);
                if (this.mobileConfig.mobilehireHealthCareInUse === 1) {
                    this.selectCurrentCustomerService.assignCurrentCustomer(dataReturned.data);
                }
                if (this.mobileConfig.mobilehireScaffoldingInUse === 2) {
                    this.loadingFetchingDocs().then(() => {
                        this.ordersListChange.emit(this.ordersList);
                        this.contractListChange.emit(this.contractList);
                    });
                }
            } else {
                if (!this.document.customer.name && this.document.documentType !== this.docTypes.SERVICEJOB) {
                    this.modalController.dismiss();
                }
            }
        });

        return await modal.present();
    }

    async loadingFetchingDocs() {
        this.loadingController.create({
            message: 'Please wait...',
            translucent: true,
            cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
        try {
            await this.refreshDocuments().then(() => {
                this.loading.dismiss();
            });
        } catch (e) {
            this.generalServices.createToast('No connection with the server');
        } finally {
            this.loading.dismiss();
        }
    }

    async refreshDocuments() {
        this.ordersList = await this.customerRes.getOrdersByCustomer(this.document.customer);
        this.contractList = await this.customerRes.getContracts(this.document.customer.id);
    }

    clearCustomer() {
        this.document.customer = new CustomerModel();
    }

    getDepotName( cod : number ){
        var depotName = 'Unknown';
        //console.log(cod);
        const xname = this.depots.filter( depot => {
            return depot.cod === cod;
        });

        if(xname.length === 1){
            depotName = xname[0].descr;
        }
        return depotName;
    }
}
